import { render, staticRenderFns } from "./addallocahis.vue?vue&type=template&id=2805e138&scoped=true&"
import script from "./addallocahis.vue?vue&type=script&lang=js&"
export * from "./addallocahis.vue?vue&type=script&lang=js&"
import style0 from "./addallocahis.vue?vue&type=style&index=0&id=2805e138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805e138",
  null
  
)

export default component.exports